module.exports = __webpack_public_path__ + "media/go.c2cc58a2.mp3";